import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image/withIEPolyfill"
import styled, { css } from "styled-components"
import { rem } from "polished"

const Goals = styled.ul`
  ${props => props.theme.gridGrid()}
`

const Goal = styled.li`
  ${props => props.theme.gridCell(4)}
  padding-bottom: ${rem(10)};
  padding-right: ${rem(10)};

  &:nth-child(3n) {
    padding-right: 0;
  }

  @media ${props => props.theme.largeDown} {
    ${props => props.theme.gridCell(6)}

    &:nth-child(2n) {
      padding-right: 0;
    }

    &:nth-child(3n) {
      padding-right: ${rem(10)};
    }
  }

  @media ${props => props.theme.xsmallDown} {
    ${props => props.theme.gridCell(12)}
    padding-right: 0;
  }

  text-align: center;
  color: ${props => props.theme.colorGrey};

  > div {
    height: 100%;
    position: relative;

    > div {
      border: solid 1px transparent;
      height: 100%;
      position: relative;
      padding: ${rem(30)} ${rem(50)};
      background-color: ${props => props.theme.colorGreyDarkest};
      background-size: 8px 8px;
      background-image: -webkit-repeating-radial-gradient(
        center center,
        rgba(255, 255, 255, 0.05),
        rgba(255, 255, 255, 0.05) 1.5px,
        transparent 1.5px,
        transparent 100%
      );
      /* TODO: replace ^ with base64 svg tile same as header  */
    }
  }

  ${props =>
    props.success &&
    css`
      > div {
        > div {
          border-color: ${props => props.theme.colorTurquoise};

          &::after {
            background-size: ${rem(20)} ${rem(20)};
            background-image: url("data:image/svg+xml;base64,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");
            position: absolute;
            top: ${rem(20)};
            right: ${rem(20)};
            z-index: 100;
            content: " ";
            width: ${rem(20)};
            height: ${rem(20)};
          }
        }

        ${GoalTitle} {
          color: ${props => props.theme.colorTurquoise};
        }

        ${GoalDescription} {
          color: ${props => props.theme.colorWhite};
        }
      }
    `}
`

const Shadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(transparent 75%, rgba(0, 0, 0, 0.3) 100%);
`
const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    transparent 60%,
    ${props => props.theme.colorBlack} 100%
  );
`

const GoalTitle = styled.h3.attrs({ className: `styled-h3` })`
  margin-bottom: ${rem(10)};
  color: ${props => props.theme.colorYellow};
`

const GoalDescription = styled.div.attrs({ className: `styled-p` })`
  color: ${props => props.theme.colorWhite};
`

const GoalImage = styled(Img)`
  margin-top: ${rem(40)};
`

const ReclamationEffortGoalsAndRewards = ({ currentReferrals, data }) => {
  return (
    <Goals>
      {data.map(({ description, title, amount, image }) => {
        return (
          <Goal
            key={`Goal${amount}`}
            success={
              typeof currentReferrals === `number` && currentReferrals >= amount
            }
          >
            <div>
              <div>
                <Gradient />
                <Shadow />

                {title && (
                  <GoalTitle dangerouslySetInnerHTML={{ __html: title }} />
                )}
                {description && (
                  <GoalDescription
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                )}
                {image && image.localFile && (
                  <GoalImage
                    fluid={image.localFile.childImageSharp.fluid}
                    role="presentation"
                    alt={title}
                  />
                )}
              </div>
            </div>
          </Goal>
        )
      })}
    </Goals>
  )
}
ReclamationEffortGoalsAndRewards.propTypes = {
  data: PropTypes.array,
  currentReferrals: PropTypes.number,
}

export default ReclamationEffortGoalsAndRewards
